import { CloseIcon } from '../tools/PeopleDataSidebar/Icons'
import { inject, observer } from 'mobx-react'
import ShareExportDropdown from './ShareExportDropdown'

export const SideBarCloseButton = ({ handleOnClick }) => {
  return (
    <button
      type='button'
      className='people-data-sidebar__close-btn'
      onClick={() => {
        handleOnClick()
      }}
    >
      <CloseIcon />
    </button>
  )
}

export const SideBarHeaderContent = ({ children, title, itemName }) => {
  return (
    <div className='people-data-sidebar__header-content' style={{ flex: 1, minWidth: 0, marginRight: '12px' }}>
      <h2 className='people-data-sidebar__title'>{title}</h2>
      <div style={{ display: 'flex', alignItems: 'center', marginTop: '4px', gap: '6px' }}>
        <span className='people-data-sidebar__folder' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 'calc(100% - 30px)' }}>
          {itemName}
        </span>
        <ShareExportDropdown />
      </div>
    </div>
  )
}

const Header = ({ uiStore, children }) => {
  const onClose = () => {
    uiStore.isPOIMenuExpanded = false
    uiStore.setActiveTab('poi')
    // this.setState({ activeTab: 'poi' })
  }
  return (
    <div className='people-data-sidebar__header'>
      {children}
      <button
        type='button'
        className='people-data-sidebar__close-btn'
        onClick={onClose}
      >
        <CloseIcon />
      </button>
    </div>

  )
}

export const SideBarHeader = inject('uiStore')(observer(Header))

export const SideBarContainer = ({ children, className }) => {
  return (
    <div className='people-data-sidebar'>
      {children}
    </div>
  )
}

export const SideBarContent = ({ children, className, style }) => {
  return (
    <div className='people-data-sidebar__content' style={style}>
      {children}
    </div>
  )
}

export const SideBarSection = ({ title, children, props }) => {
  return (
    <div className='people-data-sidebar__section' {...props}>
      <div className='people-data-sidebar__section-header'>
        <h3 className='people-data-sidebar__section-title'>{title}</h3>
      </div>
      {children}
    </div>
  )
}
